import { faker } from '@faker-js/faker';

import type { ForgotPasswordPostResponse } from '../types/ForgotPasswordPostResponse';

export function createForgotPasswordPostResponse(
  data: NonNullable<Partial<ForgotPasswordPostResponse>> = {}
): NonNullable<ForgotPasswordPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
